import React, {useId} from 'react';
import {Button, Form, Stack} from "react-bootstrap";
import {Link, useNavigate, useParams} from "react-router-dom";
import {ButtonDelete} from "../../../_components/DeleteButton";
import {useAlert, useAuth} from "../../../../context";
import {isoTimestampToReadableDate} from "../utilities/readableDate";
import {useTag} from "./useTags";
import {OurClearAlert, PageTitle, SingleText} from "../../../_components";
import {Formik, Form as FormikForm, Field, useFormikContext} from "formik";
import {WhiteCard} from "../../../device/_components/WhiteCard";

export function AddEditTags() {
    const {tid} = useParams()
    const {userId} = useAuth()
    const {success} = useAlert()
    const navigate = useNavigate()

    const {
        value,
        validationSchema,
        addItem,
        editItem,
        deleteItem,
        errorValue,
        clearErrorValue,
    } = useTag(userId, tid)

    const edit = tid !== "add"


    function handleSubmit(values, actions) {
        if (edit) {
            editItem(values)
                .then(msg => {
                    success(msg)
                    navigate(-1)
                })
                .catch(console.warn)
                .finally(() => actions.setSubmitting(false))
        } else {
            addItem(values)
                .then(msg => {
                    success(msg)
                    navigate(-1)
                })
                .catch(console.warn)
                .finally(() => actions.setSubmitting(false))
        }
    }

    function handleOnDelete() {
        deleteItem()
            .then(msg => {
                success(msg)
                navigate(-1)
            })
            .catch(console.warn)
    }

    return (
        <>
            <OurClearAlert variant="danger" msg={errorValue} onClear={clearErrorValue}/>

            <PageTitle title="Tag Details">{edit ? "Edit" : "Add"} tag.</PageTitle>

            <Formik validationSchema={validationSchema} onSubmit={handleSubmit} initialValues={value} enableReinitialize={true}>
                {({isSubmitting, resetForm}) => (
                    <FormikForm>
                        <WhiteCard>
                            <SingleText name="name" label="Name" autoFocus/>
                            <SeparatedMultipleButtons name="variant"/>
                        </WhiteCard>

                        <Stack className="my-2 text-secondary">
                            {value.created_at && <span>Created at: {isoTimestampToReadableDate(value.created_at)}</span>}
                            {value.updated_at && <span>Updated at: {isoTimestampToReadableDate(value.updated_at)}</span>}
                        </Stack>

                        <Stack direction="horizontal" gap="2" className="py-3 justify-content-end">
                            <Button as={Link} variant="link" to={-1}>Go back</Button>
                            <Button type="reset" variant="secondary" onClick={resetForm}>Reset</Button>
                            {edit && <ButtonDelete variant="danger" onDelete={handleOnDelete} value={value.name}>Delete</ButtonDelete>}
                            <Button type="submit" variant="success" disabled={isSubmitting}>Save</Button>
                        </Stack>
                    </FormikForm>
                )}
            </Formik>
        </>
    )
}

function SeparatedMultipleButtons({name}) {
    const {values} = useFormikContext();

    const colors = ["primary", "secondary", "success", "danger", "warning", "info", "dark"]

    return <Field name={name}>
        {({field, meta}) => (
            <Form.Group controlId={useId()} className="my-2">
                <Form.Label column="" className="text-capitalize">Color</Form.Label>
                <div>
                    {colors.map((color, index) => (

                        <Button
                            key={index}
                            className="m-1"
                            variant={`${field.value === color ? "" : "outline-"}${color}`}
                            // active={field.value === color}
                            onClick={() => field.onChange({target: {name: name, value: color}})}
                        >
                            {values.name}
                        </Button>
                    ))}
                </div>
                <Form.Control hidden isInvalid={meta.touched && !!meta.error}/>
                <Form.Control.Feedback type="invalid">{meta.error}</Form.Control.Feedback>
            </Form.Group>
        )}
    </Field>
}
